// « Créée parce que : … » on the order page (owner, 2026-10-06: « EXPLAIN
// EVERY ORDER … so I can audit the decisions and correct the Brain »).
//
// The sentence is written once, in French, by the door that made the order
// (worker/src/lib/orderIntent.ts — `becauseText`, migration 220). An order made
// before that has none, and nothing is invented for it.
import { useT } from '@/lib/i18n';

export interface CreatedBecauseFields {
  created_because?: string | null;
  created_because_source?: string | null;
}

export function CreatedBecause({ order }: { order: CreatedBecauseFields }) {
  const { t } = useT();
  const text = String(order.created_because ?? '').trim();
  if (!text) return null;
  const source = String(order.created_because_source ?? '').trim() || null;
  return (
    <div data-source={source ?? undefined}>
      <dt className="text-xs text-gray-400 mb-0.5">{t('Créée parce que')}</dt>
      <dd className={`font-medium text-sm ${source === 'model' ? 'text-amber-700' : 'text-gray-800'}`}>{text}</dd>
    </div>
  );
}
